import styled from 'styled-components';

export const Container = styled.div`
    //display:flex;
    //flex-direction: column;
    //align-items:center;
    height:100%;
    overflow-y: auto;
    padding: 15px;

`;
export const Pergunta = styled.div`
    display: flex;
    flex-direction:column;
    margin-bottom: 10px;
`;
